import { render } from "./BlackjackDialog.vue?vue&type=template&id=621dacb5&scoped=true"
import script from "./BlackjackDialog.vue?vue&type=script&lang=js"
export * from "./BlackjackDialog.vue?vue&type=script&lang=js"

import "./BlackjackDialog.vue?vue&type=style&index=0&id=621dacb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621dacb5"]])

export default __exports__